<div class="sw-in-app-purchase-checkout-purchase">
    <div class="sw-in-app-purchase-checkout-purchase__feature">
        <p class="sw-in-app-purchase-checkout-purchase__feature__name">
            {{ purchase.name }}
        </p>

        <p class="sw-in-app-purchase-checkout-purchase__feature__description">
            {{ purchase.description }}
        </p>
    </div>

    <sw-in-app-purchase-price-box
        v-if="purchase.priceModels.length === 1"
        :price-model="priceModel"
    />

    <sw-radio-field
        v-else
        block
        :options="purchaseOptions"
        class="sw-in-app-purchase-checkout-purchase__feature__choices"
        @update:value="setPriceModel"
    />

    <div class="sw-in-app-purchase-checkout-purchase__subtext">
        <p class="sw-in-app-purchase-checkout-purchase__subtext__bill">
            {{ $t('sw-in-app-purchase-checkout-overview.billHint') }}
        </p>

        <p class="sw-in-app-purchase-checkout-purchase__subtext__exclude_vat">
            {{ $t('sw-in-app-purchase-checkout-overview.excludeVat') }}
        </p>

        <mt-checkbox
            v-if="priceModel.conditionsType !== null"
            v-model:value="gtcAccepted"
            :checked="gtcAccepted"
            class="sw-in-app-purchase-checkout-purchase__subtext__partner_gtc"
            @update:checked="onGtcAcceptedChange"
        >
            <template #label>
                {{ $t('sw-in-app-purchase-checkout-overview.partner.accept') }}
                <mt-link
                    v-if="priceModel.conditionsType === 'gtc'"
                    type="external"
                    as="a"
                    :href="purchase.websiteGtc"
                >
                    {{ $t('sw-in-app-purchase-checkout-overview.partner.gtc', { partner: producer }, 0) }}
                </mt-link>
                <mt-link
                    v-else-if="priceModel.conditionsType === 'detailed'"
                    type="internal"
                    as="button"
                    @click="openConditionsModal()"
                >
                    {{ $t('sw-in-app-purchase-checkout-overview.partner.conditions', { partner: producer }, 0) }}
                </mt-link>
            </template>
        </mt-checkbox>

        <sw-gtc-checkbox
            :value="tosAccepted"
            class="sw-in-app-purchase-checkout-purchase__subtext__tos"
            @update:value="onTosAcceptedChange"
        />
    </div>

    <sw-modal
        v-if="priceModel.conditionsType === 'detailed' && showConditionsModal"
        :title="$t('sw-in-app-purchase-checkout-overview.partner.conditions-header')"
        variant="small"
        @modal-close="closeConditionsModal"
    >
        <div v-html="$sanitize(purchase.serviceConditions, { ALLOWED_TAGS: ['a', 'b', 'i', 'u', 'br', 'ul', 'li', 'ol'], ALLOWED_ATTR: ['href', 'target'] })" />

        <template #modal-footer>
            <sw-button
                variant="secondary"
                @click="closeConditionsModal"
            >
                {{ $t('sw-in-app-purchase-checkout-button.closeButton') }}
            </sw-button>
        </template>
    </sw-modal>
</div>
